'use client';

import { useEffect } from 'react';

import { useLocalStorage } from '@uidotdev/usehooks';

import { useGetFeatureFlag } from '@/lib/feature-flags/hooks/use-get-feature-flag';
import type { FeatureFlagVariant } from '@/lib/feature-flags/types';

const SIGN_UP_Q1_VARIANT_STORAGE_KEY = '__ab_test_sign_up_2026_q1_variant';

interface UseSignUpQ1VariantReturn {
  isReady: boolean;
  variant: FeatureFlagVariant | undefined;
}

export function useSignUpQ1Variant(): UseSignUpQ1VariantReturn {
  const [storedVariant, setStoredVariant] = useLocalStorage<FeatureFlagVariant | null>(
    SIGN_UP_Q1_VARIANT_STORAGE_KEY,
    null,
  );

  const posthogVariant = useGetFeatureFlag('ab_test_sign_up_2026_q1');
  const variant = posthogVariant ?? storedVariant ?? undefined;

  useEffect(() => {
    if (posthogVariant === undefined || storedVariant === posthogVariant) {
      return;
    }

    setStoredVariant(posthogVariant);
  }, [storedVariant, posthogVariant, setStoredVariant]);

  return {
    isReady: variant !== undefined,
    variant,
  };
}
